import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const AdminRoute = ({ children }) => {
  const { user, loading, refreshUser, logout } = useAuth();
  const [verified, setVerified] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (loading || !user) {
      setChecking(false);
      return;
    }
    // Validate the token server-side to prevent localStorage tampering
    refreshUser()
      .then(() => setVerified(true))
      .catch(() => { logout(); })
      .finally(() => setChecking(false));
  }, [loading, user]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading || checking) {
    return <div className="loading">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  if (user.role !== 'admin') {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default AdminRoute;